import { Divider, TableContainer, Paper, Table, TableHead, TableRow, TableCell, TableSortLabel, TableBody } from '@mui/material';
import React from 'react';
import { Sale, SaleFilterData } from 'models';
import {
	TableErrorMessage,
	TableLoadingBar,
	SaleRow, SalesFilterPane,
	TablePaginationFooter,
	SaleForm
} from 'components';
import { useTableContext } from 'hooks';
import { useSales } from 'hooks';
import { TableEmptyRow } from 'components';

export const SaleTable = () => {
	const { sales, isFetching, error, filterFunction } = useSales();
	const {
		visibleData,
		page,
		rowsPerPage,
		order,
		orderBy,
		handlePageChange,
		handleChangeRowsPerPage,
		filterData,
		setFilterData,
		handleSort
	} = useTableContext<Sale, SaleFilterData>({ data: sales, filterFunction })
	return (
		<>
			<SalesFilterPane filterData={filterData} setData={setFilterData} />
			<Divider />
			<TableContainer component={Paper}>
				<Table aria-label='collapsible table'>
					<TableHead>
						<TableRow>
							<TableCell colSpan={1} />
							<TableCell colSpan={2}>
								<TableSortLabel active={orderBy === 'timeStamp'} direction={orderBy === 'timeStamp' ? order : 'asc'} onClick={() => handleSort('timeStamp')}></TableSortLabel>
								Date
							</TableCell>
							<TableCell colSpan={4}>
								<TableSortLabel active={orderBy === 'user'} direction={orderBy === 'user' ? order : 'asc'} onClick={() => handleSort('user')}></TableSortLabel>
								Customer
							</TableCell>
							<TableCell colSpan={4}>
								<TableSortLabel active={orderBy === 'product'} direction={orderBy === 'product' ? order : 'asc'} onClick={() => handleSort('product')}></TableSortLabel>
								Product
							</TableCell>
						</TableRow>
					</TableHead>
					<TableBody>
						{isFetching && <TableLoadingBar colSpan={10} />}
						{error && <TableErrorMessage error={error} colSpan={10}></TableErrorMessage>}
						{!isFetching && visibleData && (
							<>
								<TableEmptyRow formComponent={<SaleForm />} />
								{visibleData.map((row: Sale) => (
									<SaleRow key={row.id} row={row} />
								))}
							</>
						)}
					</TableBody>
				</Table>
			</TableContainer>
			<TablePaginationFooter totalRows={sales?.length ?? 0} page={page} rowsPerPage={rowsPerPage} handlePageChange={handlePageChange} handleChangeRowsPerPage={handleChangeRowsPerPage} />
		</>
	);
}
